module.exports = __webpack_public_path__ + "static/media/vg.0f302212.svg";